import AddInsurance from './AddInsurance';

export default AddInsurance;
